import { memo } from "react";
import PropTypes from "prop-types";
import InfiniteScroll from "react-infinite-scroll-component";
import { Skeleton } from "antd";
import Row from "antd/lib/row";
import { useDispatch } from "react-redux";
import {
  triggerModalSetTag,
  createTagRequest,
} from "providers/MessengerProvider/slice";
import { setPopup } from "providers/GeneralProvider/slice";
import ConversationCell from "./ConversationCell";
import "./styles.less";

// Skeleton component for loading state
const ConversationSkeleton = () => (
  <div style={{ padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 12, borderBottom: '1px solid #f0f0f0' }}>
    <Skeleton.Avatar active size={40} />
    <div style={{ flex: 1 }}>
      <Skeleton.Input active size="small" style={{ width: 120, marginBottom: 8 }} />
      <Skeleton.Input active size="small" style={{ width: 180 }} />
    </div>
  </div>
);

const ConversationList = ({
  conversationIds,
  conversationEntities,
  onConversationCellClick,
  activeConversationId,
  getConversationList,
  hasMore = true,
  currentUserId,
  isGettingList = false,
}) => {
  const dispatch = useDispatch();

  const _onDeleteTag = (data) => {
    dispatch(
      setPopup({
        isOpen: true,
        data: {
          title: "Xoá tag",
          content: "Bạn có muốn xoá tag cho người dùng này?",
          okText: "OK",
          cancelText: "Huỷ",
          onOk: () => {
            dispatch(
              createTagRequest({
                conversationId: data._id,
                name: " ",
                color: "blue",
              })
            );
          },
        },
      })
    );
  };

  // Wrapper to prevent duplicate requests when already loading
  const handleLoadMore = () => {
    if (!isGettingList && hasMore) {
      getConversationList();
    }
  };

  return (
    <div
      className="conversation-list-container"
      id="scrollable-conversation-list"
    >
      <InfiniteScroll
        scrollThreshold="100px"
        dataLength={conversationIds.length}
        next={handleLoadMore}
        hasMore={hasMore && !isGettingList}
        loader={
          <div>
            <ConversationSkeleton />
            <ConversationSkeleton />
            <ConversationSkeleton />
          </div>
        }
        scrollableTarget="scrollable-conversation-list"
        endMessage={
          <Row style={{ padding: 8 }} justify="center">
            <span style={{ color: '#666', fontSize: '12px' }}>No more conversations</span>
          </Row>
        }
      >
        {conversationIds.map((id) => (
          <ConversationCell
            className={activeConversationId === id ? "active-conversation" : ""}
            onClick={() => onConversationCellClick(id)}
            key={id}
            data={conversationEntities[id]}
            currentUserId={currentUserId}
            onClickTag={(data) => {
              dispatch(
                triggerModalSetTag({
                  visible: true,
                  data,
                })
              );
            }}
            onDeleteTag={_onDeleteTag}
          />
        ))}
      </InfiniteScroll>
    </div>
  );
};

ConversationList.propTypes = {
  conversationIds: PropTypes.array.isRequired,
  conversationEntities: PropTypes.object.isRequired,
  onConversationCellClick: PropTypes.func.isRequired,
  activeConversationId: PropTypes.string.isRequired,
  getConversationList: PropTypes.func.isRequired,
  hasMore: PropTypes.bool.isRequired,
  currentUserId: PropTypes.string.isRequired,
  isGettingList: PropTypes.bool,
};

export default memo(ConversationList);
